import React, { useEffect, useRef } from "react";

import logoUnitiva from "../../assets/logo-pictogram.svg";

import * as S from "./style";
interface LoaderOverlayProps {
  isWhite?: boolean;
}

const LoaderOverlay: React.FC<LoaderOverlayProps> = (props) => {
  const overlayLoader = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined") {
      document.documentElement.style.overflow = "hidden";

      if (overlayLoader.current) {
        overlayLoader.current.addEventListener("animationend", () => {
          document.documentElement.style.overflowX = "hidden";
          document.documentElement.style.overflowY = "initial";
        });
      }
    }
  }, []);

  return (
    <S.LoaderWrapper isWhite={props.isWhite}>
      <div className="loader loader__inner-page">
        <div className="loader__svg loader__icon-gradient">
        <img src={logoUnitiva} alt="Unitiva" /> 
        </div>
      </div>
      <div ref={overlayLoader} className="loader__overlay__inner-page"></div>
    </S.LoaderWrapper>
  );
};

export default LoaderOverlay;
